import {
  PhoneCall,
  Envelope,
  IdentificationCard,
  Chats,
  FacebookLogo,
  CaretUp,
  CaretDown,
  User,
  ArrowLeft,
  ArrowRight,
  Question,
  CaretRight,
  Package,
  Copy,
  GasPump,
  CloudRain,
  SpeakerHigh,
  FileText,
  SlidersHorizontal,
  ArrowLineLeft,
  ArrowLineRight,
  Truck,
  Users,
  FilePdf,
  DownloadSimple,
  X,
  SignOut,
  List,
  CaretLeft
} from 'phosphor-react';
import TruckContainer from './TruckContainer';

export const icons = {
  phone: PhoneCall,
  envelope: Envelope,
  identificationCard: IdentificationCard,
  chats: Chats,
  facebookLogo: FacebookLogo,
  caretUp: CaretUp,
  caretDown: CaretDown,
  user: User,
  arrowLeft: ArrowLeft,
  arrowRight: ArrowRight,
  question: Question,
  caretRight: CaretRight,
  slidersHorizontal: SlidersHorizontal,
  package: Package,
  copy: Copy,
  gasPump: GasPump,
  cloudRain: CloudRain,
  speakerHigh: SpeakerHigh,
  fileText: FileText,
  arrowLineLeft: ArrowLineLeft,
  arrowLineRight: ArrowLineRight,
  truck: Truck,
  users: Users,
  filePdf: FilePdf,
  downloadSimple: DownloadSimple,
  signOut: SignOut,
  x: X,
  'truck-container': TruckContainer,
  list: List,
  caretLeft: CaretLeft,
};
